import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { FormProvider, useForm, useFormContext } from 'react-hook-form';
import { Box, Callout, Column, ConfirmationModal, Typography } from 'seagull';
import { ContactForm } from '~/components/ContactForm/ContactForm';
import { useLocaleKeys } from '~/i18n';
import { CONTACT_FIELD_NAME, GetEditContactIdentityModalTID, belongsToManyClients, compactPhone, editContactIdentityModalTextsPath } from './EditContactIdentityModal.utils';
import { useSubmitContactIdentity } from './hooks/useSubmitContactIdentity';
const EditContactIdentityModalContent = (param)=>{
    let { contact, dismissModal, testId } = param;
    const { t } = useLocaleKeys(editContactIdentityModalTextsPath);
    const { EditContactIdentityModalTestIds } = useMemo(()=>GetEditContactIdentityModalTID(testId), [
        testId
    ]);
    const { handleSubmit } = useFormContext();
    const { errorMessage, submit } = useSubmitContactIdentity({
        contact,
        dismissModal,
        successToastTestId: EditContactIdentityModalTestIds.SuccessToast(),
        guardTestIds: {
            anchorUserWarning: EditContactIdentityModalTestIds.AnchorUserWarning(),
            withdrawProposals: EditContactIdentityModalTestIds.WithdrawProposals(),
            errorToast: EditContactIdentityModalTestIds.GuardErrorToast()
        }
    });
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        openBottomSheetOnMobile: true,
        title: t.title(),
        primaryButtonLabel: t.saveButton(),
        secondaryButtonLabel: t.cancelButton(),
        testId: EditContactIdentityModalTestIds.Root(),
        textAlignCenter: false,
        primaryButtonTestId: EditContactIdentityModalTestIds.SaveButton(),
        secondaryButtonTestId: EditContactIdentityModalTestIds.CancelButton(),
        bi: {
            primaryButton: {
                name: 'edit_contact_identity_submit'
            },
            secondaryButton: {
                name: 'edit_contact_identity_cancel'
            },
            closeButton: {
                name: 'edit_contact_identity_close'
            }
        },
        onPrimaryButtonClick: handleSubmit(submit),
        onSecondaryButtonClick: dismissModal,
        onCloseButtonClick: dismissModal,
        content: /*#__PURE__*/ _jsxs(Column, {
            gap: 24,
            children: [
                belongsToManyClients(contact) && /*#__PURE__*/ _jsx(Callout, {
                    intent: "info",
                    testId: EditContactIdentityModalTestIds.CrossClientCallout(),
                    children: t.crossClientNotice()
                }),
                /*#__PURE__*/ _jsx(ContactForm, {
                    namePrefix: CONTACT_FIELD_NAME,
                    testId: EditContactIdentityModalTestIds.ContactForm()
                }),
                errorMessage != null && /*#__PURE__*/ _jsx(Box, {
                    testId: EditContactIdentityModalTestIds.SaveError(),
                    children: /*#__PURE__*/ _jsx(Typography, {
                        variant: "paragraph2",
                        skin: "error",
                        children: errorMessage
                    })
                })
            ]
        })
    });
};
export const EditContactIdentityModal = (props)=>{
    const methods = useForm({
        mode: 'all',
        defaultValues: {
            [CONTACT_FIELD_NAME]: {
                firstName: props.contact.firstName,
                lastName: props.contact.lastName,
                email: props.contact.email,
                phone: compactPhone(props.contact.phone)
            }
        }
    });
    return /*#__PURE__*/ _jsx(FormProvider, _object_spread_props(_object_spread({}, methods), {
        children: /*#__PURE__*/ _jsx(EditContactIdentityModalContent, _object_spread({}, props))
    }));
};
